import { render, staticRenderFns } from "./vente.vue?vue&type=template&id=126c04c5&"
import script from "./vente.vue?vue&type=script&lang=js&"
export * from "./vente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports